// New
const floorplanSize = (layoutName) => {
  function containsNumbers(str) {
    return /[0-9]/.test(str);
  }

  const hasNumber = layoutName ? containsNumbers(layoutName.split('.')[0]) : false;
  var layoutNameArr1L = layoutName.split('.').length;
  var layoutNameArr2L = layoutName.split('-').length;
  var modelNameFT = (layoutNameArr1L > 2 && layoutNameArr2L == 3 ? `${layoutName.split('.')[0]}ft - ${layoutName.split('.')[1].split('-')[1]}` : layoutName);

  return !hasNumber ? modelNameFT.replace('ft', ''): modelNameFT
}

// Legacy
const getFloorplanSize = (layoutName) => {
  if (!layoutName) {
    return layoutName
  }
  const size = layoutName.match(/(\d+)/); 
  const isNumber = size ? !isNaN(parseFloat(size[0])) && isFinite(size[0]) : null;
  return isNumber ? `${size[0]} ft` : layoutName;
}

export {floorplanSize, getFloorplanSize as default}

